export enum mgmHelloBarTypes {
  threeDays = 3,
  fifteenDays = 15,
}
